import { VesselSpec } from '@navstation-portal/vessels/data-model/vessel';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { VESSEL_SPEC_STORE_ID } from './constants';

export const vesselSpecEvents = eventGroup({
  source: VESSEL_SPEC_STORE_ID,
  events: {
    fetchVesselSpec: type<string>(),
    fetchVesselSpecSuccess: type<VesselSpec>(),
    fetchVesselSpecFailed: type<Error>(),
    updateVesselSpec: type<{
      vesselId: string;
      body: {
        information: Record<string, unknown>;
        form: Record<string, unknown>;
      };
    }>(),
    updateVesselSpecSuccess: type<void>(),
    updateVesselSpecFailed: type<Error>(),
    clearVesselSpec: type<void>(),
  },
});
